export const authKeys = {
  all: ['auth'] as const,
  currentUser: ['auth', 'currentUser'] as const,
} as const;

